export default __webpack_public_path__ + "i18n/translations/translation-pt.b0260dd1.json";